module.exports = __webpack_public_path__ + "hot-n8Uwsmo.svg";